import React, { useState } from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { jwtDecode } from 'jwt-decode';

const GoogleOAuthTest = () => {
  const [testResult, setTestResult] = useState(null);
  const [clientId, setClientId] = useState(import.meta.env.VITE_GOOGLE_CLIENT_ID);

  const handleSuccess = (credentialResponse) => {
    try {
      const decoded = jwtDecode(credentialResponse.credential);
      setTestResult({
        success: true,
        message: 'Google OAuth funcionando correctamente',
        user: {
          name: decoded.name,
          email: decoded.email,
          picture: decoded.picture
        },
        credential: credentialResponse.credential.substring(0, 50) + '...'
      });
    } catch (error) {
      setTestResult({
        success: false,
        message: 'Error decodificando token',
        error: error.message
      });
    }
  };

  const handleError = () => {
    setTestResult({
      success: false,
      message: 'Error en Google OAuth',
      error: 'Falló la autenticación con Google'
    });
  };

  const validateClientId = () => {
    const issues = [];
    
    if (!clientId) {
      issues.push('Client ID no configurado');
    } else {
      if (!clientId.includes('.apps.googleusercontent.com')) {
        issues.push('Client ID no tiene el formato correcto');
      }
      if (clientId.length < 50) {
        issues.push('Client ID parece estar incompleto');
      }
      if (clientId === 'your-google-client-id') {
        issues.push('Client ID es el valor por defecto');
      }
    }
    
    return issues;
  };

  const clientIdIssues = validateClientId();

  return (
    <div style={{
      padding: '20px',
      margin: '20px',
      border: '1px solid #ddd',
      borderRadius: '8px',
      backgroundColor: '#f9f9f9'
    }}>
      <h2>🧪 Test de Google OAuth</h2>
      
      <div style={{ marginBottom: '20px' }}>
        <h3>📋 Configuración Actual:</h3>
        <p><strong>Client ID:</strong> {clientId || 'No configurado'}</p>
        <p><strong>Longitud:</strong> {clientId ? clientId.length : 0} caracteres</p>
        
        {clientIdIssues.length > 0 && (
          <div style={{ 
            backgroundColor: '#ffebee', 
            padding: '10px', 
            borderRadius: '4px',
            marginTop: '10px'
          }}>
            <h4>⚠️ Problemas detectados:</h4>
            <ul>
              {clientIdIssues.map((issue, index) => (
                <li key={index} style={{ color: '#d32f2f' }}>{issue}</li>
              ))}
            </ul>
          </div>
        )}
      </div>

      <div style={{ marginBottom: '20px' }}>
        <h3>🔐 Test de Autenticación:</h3>
        {clientIdIssues.length === 0 ? (
          <GoogleLogin
            onSuccess={handleSuccess}
            onError={handleError}
            text="signin_with"
            shape="rectangular"
            theme="outline"
            size="large"
          />
        ) : (
          <p style={{ color: '#d32f2f' }}>❌ No se puede probar hasta resolver los problemas de configuración</p>
        )}
      </div>

      {testResult && (
        <div style={{
          backgroundColor: testResult.success ? '#e8f5e8' : '#ffebee',
          padding: '15px',
          borderRadius: '4px',
          marginTop: '20px'
        }}>
          <h3>{testResult.success ? '✅' : '❌'} Resultado del Test:</h3>
          <p><strong>Mensaje:</strong> {testResult.message}</p>
          
          {testResult.success && testResult.user && (
            <div>
              <p><strong>Usuario:</strong> {testResult.user.name}</p>
              <p><strong>Email:</strong> {testResult.user.email}</p>
              <p><strong>Token:</strong> {testResult.credential}</p>
            </div>
          )}
          
          {testResult.error && (
            <p style={{ color: '#d32f2f' }}><strong>Error:</strong> {testResult.error}</p>
          )}
        </div>
      )}

      <div style={{ marginTop: '20px', fontSize: '14px', color: '#666' }}>
        <h4>📝 Instrucciones para configurar Google OAuth:</h4>
        <ol>
          <li>Ve a <a href="https://console.cloud.google.com/" target="_blank" rel="noopener noreferrer">Google Cloud Console</a></li>
          <li>Selecciona tu proyecto o crea uno nuevo</li>
          <li>Ve a "APIs y servicios" → "Credenciales"</li>
          <li>Crea un "ID de cliente OAuth 2.0"</li>
          <li>Configura los orígenes autorizados:
            <ul>
              <li>http://localhost:3000</li>
              <li>http://localhost:5173</li>
            </ul>
          </li>
          <li>Copia el Client ID completo al archivo .env</li>
          <li>Reinicia el servidor de desarrollo</li>
        </ol>
      </div>
    </div>
  );
};

export default GoogleOAuthTest;